module.exports = __webpack_public_path__ + "static/media/icon-trash-alt.5dda1f39.svg";